import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

// New minimalistic version components (default - loaded eagerly)
import { HeaderMinimal } from '@/components/homepage/HeaderMinimal';
import { HeroCompact } from '@/components/homepage/HeroCompact';
import { PlatformIndex } from '@/components/homepage/PlatformIndex';
import { FooterMinimal } from '@/components/homepage/FooterMinimal';

// Classic version components (lazy-loaded, only when ?v=classic)
const Header = lazy(() => import('@/components/homepage/Header').then(m => ({ default: m.Header })));
const Hero = lazy(() => import('@/components/homepage/Hero').then(m => ({ default: m.Hero })));
const Features = lazy(() => import('@/components/homepage/Features').then(m => ({ default: m.Features })));
const Architecture = lazy(() => import('@/components/homepage/Architecture').then(m => ({ default: m.Architecture })));
const Benefits = lazy(() => import('@/components/homepage/Benefits').then(m => ({ default: m.Benefits })));
const Footer = lazy(() => import('@/components/homepage/Footer').then(m => ({ default: m.Footer })));

const searchSchema = z.object({
  v: z.enum(['classic']).optional(),
});

export const Route = createFileRoute('/')({
  component: HomePage,
  validateSearch: searchSchema,
});

function HomePage() {
  const { v } = Route.useSearch();
  const isClassic = v === 'classic';

  if (isClassic) {
    // Classic version with dropdowns (lazy-loaded)
    return (
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <div className="min-h-screen bg-background">
          <Header />
          <main>
            <Hero />
            <Features />
            <Architecture />
            <Benefits />
          </main>
          <Footer />
        </div>
      </Suspense>
    );
  }

  // New minimalistic version (default)
  return (
    <div className="min-h-screen bg-background">
      <HeaderMinimal />
      <main>
        <HeroCompact />
        <PlatformIndex />
      </main>
      <FooterMinimal />
    </div>
  );
}
